import {
  Box,
  Typography,
  useTheme
} from '@mui/material';
import { useAccessState } from 'modules/common';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveDailyReportModal } from 'modules/components/layer17';
import React, { useState } from 'react';

export type DailyReportDescriptionCardProps = {
  id: string;
  description: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DailyReportDescriptionCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const theme = useTheme();
  const access = useAccessState('DailyReport');
  return (
    <>
      {isVisible && (
        <SaveDailyReportModal.FC
          id={props.id}
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <ActivityDetailSectionCardBaseLayout.FC
        title='General'

        subTitle='Summarize any information to be recorded'
        actionButton={null}
        editActionButton={{
          onClick: () => {
            setIsVisible(() => true);
          },
          text: 'Edit',
          disabled: !access.update
        }}
        boxProps={{
          flex: '1 1 0'
        }}
      >

        <Box
          bgcolor={theme.palette.secondary.main}
          borderRadius='1rem'
          padding='1rem'
          minHeight='10rem'
        >

          <Typography
            variant='body1'
          >
            {props.description}
          </Typography>

        </Box>

      </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
